/** Today's date as YYYY-MM-DD (local calendar day via UTC ISO slice — matches existing app usage). */
export function todayISODate() {
  return new Date().toISOString().split("T")[0];
}

/** Earliest allowed contract end: today or contract start, whichever is later. */
export function minContractEndDate(contractStart) {
  const today = todayISODate();
  const start = contractStart || today;
  return start > today ? start : today;
}

/** Returns an error message, or null when the contract end date is valid. */
export function validateContractEnd(contractEnd, contractStart) {
  if (!contractEnd) return "Contract end date is required.";

  const today = todayISODate();
  if (contractEnd < today) {
    return "Contract end date must be today or a future date.";
  }

  const start = contractStart || today;
  if (contractEnd < start) {
    return "Contract end date must be on or after the contract start date.";
  }

  return null;
}
